import store from "../store";

export const isSuperManger = () => {
  const isSuperManger = store.getState().auth?.login?.personal_data?.is_super_manager;
  return isSuperManger;
};
